// extracted by mini-css-extract-plugin
export default {"mainLayout":"main-layout_mainLayout__0425J","footer":"main-layout_footer__UXrYb","rotate":"main-layout_rotate__+Cv-P"};